/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:49
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-11-17 14:34:37
 */
import { Drawer, Icon } from '@firesoon/antd';
import React, { FC } from 'react';
import Button from '../Button';
import { DrawerP, InitialFooterP } from './interface';

import './index.less';

// 默认页脚
const initialFooter = (props: InitialFooterP) => {
  const { okText, cancelText, okButtonProps, cancelButtonProps, onOk, onClose } = props;

  return [
    <Button key="cancel" {...cancelButtonProps} onClick={onClose}>
      {cancelText ?? '取消'}
    </Button>,

    <Button key="ok" type="primary" style={{ marginLeft: 16 }} {...okButtonProps} onClick={onOk}>
      {okText ?? '确认'}
    </Button>,
  ];
};

const Index: FC<DrawerP> = ({
  okText,
  cancelText,
  onOk,
  onClose,
  okButtonProps,
  cancelButtonProps,
  footer = initialFooter({ okText, cancelText, onOk, onClose, okButtonProps, cancelButtonProps }),
  children,
  width = 640,
  className = '',
  closable = true,
  ...rest
}) => {
  const footerRender =
    footer === null ? null : (
      <div className="fs-drawer-footer">{footer instanceof Array ? footer.map((v) => v) : footer}</div>
    );

  /** 因为ie10存在问题，所以子啊antd源码button上加了type属性，防止input enter时触发关闭 */
  const renderCloseIcon = closable && (
    <button type="button" onClick={onClose} aria-label="Close" className="ant-drawer-close">
      <Icon type="close" />
    </button>
  );

  return (
    <Drawer
      width={width}
      className={`fs-drawer ${className}`}
      maskClosable={false}
      {...rest}
      onClose={onClose}
      closable={false}
    >
      {renderCloseIcon}
      {children}
      {footerRender}
    </Drawer>
  );
};

export default Index;
